module.exports = "/_next/static/images/0a68700a1e6fe2b0fcb695b4396cc86d-nuconta-inclined-device@0.75x.png.webp";